import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  translationConstants,
  boatTypeEnumReversed,
  levelEnumReversed,
  proficiencyLevelEnumReversed,
} from "../../../constants";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RejectIcon from "../../../assets/images/icon/reject_icon.svg";
import {
  PlusIcon,
  TableViewIcon,
} from "../../../assets/images/icon/iconsProvider";
import { UserActions } from "../../../redux/actions";
import { getSportIconAndHeading } from "../../../system";
import ViewCertificateAttachments from "../Modals/ViewCertificateAttachments";

const SportType = ({ isShowAddButton = false, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [transformedData, setTransformedData] = useState([]);
  const [selectedQualifications, setSelectedQualifications] = useState([]);
  const [isViewAttachmentModal, setViewAttachmentModal] = useState(false);

  const handleViewAttachments = (qualifications) => {
    setSelectedQualifications(qualifications);
    setViewAttachmentModal(true);
  };

  const formState = useSelector(
    (state) => state?.UserReducer?.qualificationDocFormState
  );

  const transformFormState = (formState) => {
    const transformedState = [];
    formState?.forEach((entry) => {
      const {
        sportId,
        boatTypeId,
        dateOfCompletionString,
        qualifications,
        levelId,
        proficiencyLevelId,
      } = entry;

      // Find the existing sport group
      let sportGroup = transformedState.find(
        (sport) => sport.sportId === sportId
      );

      // If the sport group doesn't exist, create it
      if (!sportGroup) {
        sportGroup = {
          sportId: sportId,
          boatTypeLevels: [],
        };
        transformedState.push(sportGroup);
      }

      // Add the boat type level entry
      sportGroup.boatTypeLevels.push({
        boatTypeId: boatTypeId,
        dateOfCompletionString: dateOfCompletionString,
        qualifications: qualifications,
        levelId: levelId,
        proficiencyLevelId: proficiencyLevelId,
      });
    });
    return transformedState;
  };

  useEffect(() => {
    setTransformedData(transformFormState(formState));
  }, [formState]);

  const deleteByLevelId = (formState, rowData) => {
    const updatedData = formState.filter((item) => {
      // Keep the item if NOT all three conditions are true
      return !(
        item.boatTypeId === rowData.boatTypeId &&
        item.levelId === rowData.levelId &&
        item.proficiencyLevelId === rowData.proficiencyLevelId
      );
    });

    dispatch(UserActions.setQualificationFormState(updatedData));
  };

  return (
    <div className="SportDataForm w-100">
      {isShowAddButton && (
        <Row>
          <Col lg={8}>
            <p className="Sport_Type">{t(translationConstants.sportType)}:</p>
            <p className="Sport_Type">
              <span>{t(translationConstants.selectSport)}</span>
            </p>
          </Col>

          <Col className="d-flex justify-content-center justify-content-lg-end align-items-center mt-3 mt-lg-0">
            <Button
              className="Registeration-button m-0"
              onClick={() => {
                props?.setAddQualificationModal((prev) => !prev);
              }}
            >
              <PlusIcon />
              &nbsp;
              {t(translationConstants.ADD_NEW)}
            </Button>
          </Col>
        </Row>
      )}

      <div className="certificate-accordion-modal">
        {transformedData?.map((document) => {
          const { icon, heading } = getSportIconAndHeading(
            t,
            document?.sportId
          );

          return (
            <Accordion data-column-id="certificates" className="w-100">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="expandIcon" />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
              >
                {icon && <img src={icon} className="px-2" alt="sportIcon" />}
                {heading && heading}
              </AccordionSummary>
              <AccordionDetails className="accordion-details">
                <section className="accordion-details-container">
                  <Row className="accordion-detail-heading">
                    <Col className="" xs={2}>
                      {t(translationConstants.BOAT_TYPE)}
                    </Col>
                    <Col className="" xs={3}>
                      {t(translationConstants.COMPLETION_DATE)}
                    </Col>
                    <Col className="" xs={3}>
                      {t(translationConstants.SUGGESTED_LEVEL)}
                    </Col>
                    <Col className="" xs={2}>
                      {t(translationConstants.ATTACHMENTS)}
                    </Col>
                    <Col className="" xs={2}></Col>
                  </Row>
                  {document.boatTypeLevels?.map((boatTypeLevels) => {
                    return (
                      <>
                        <Row className="accordion-detail-content mt-1">
                          <Col className=" align-self-center" xs={2}>
                            {t(
                              translationConstants[
                                boatTypeEnumReversed[boatTypeLevels.boatTypeId]
                              ]
                            )}
                          </Col>
                          <Col className=" align-self-center" xs={3}>
                            {boatTypeLevels.dateOfCompletionString.substring(
                              0,
                              10
                            )}
                          </Col>
                          <Col className=" align-self-center" xs={3}>
                            {t(
                              translationConstants[
                                levelEnumReversed[boatTypeLevels.levelId]
                              ]
                            )}
                            {boatTypeLevels.proficiencyLevelId &&
                              ` - ${t(
                                translationConstants[
                                  proficiencyLevelEnumReversed[
                                    boatTypeLevels.proficiencyLevelId
                                  ]
                                ]
                              )}`}
                          </Col>
                          <Col
                            className=" d-flex justify-content-center align-items-center"
                            xs={2}
                          >
                            <TableViewIcon
                              onClick={() => {
                                handleViewAttachments(
                                  boatTypeLevels.qualifications
                                );
                              }}
                            />
                          </Col>
                          <Col
                            className=" d-flex justify-content-center align-items-center"
                            xs={2}
                          >
                            <img
                              className="cursor-pointer"
                              src={RejectIcon}
                              alt="removeIcon"
                              onClick={() => {
                                deleteByLevelId(formState, boatTypeLevels);
                              }}
                            />
                          </Col>
                        </Row>
                      </>
                    );
                  })}
                </section>
              </AccordionDetails>
            </Accordion>
          );
        })}

        {isViewAttachmentModal && (
          <ViewCertificateAttachments
            isViewAttachmentModal={isViewAttachmentModal}
            setViewAttachmentModal={setViewAttachmentModal}
            qualifications={selectedQualifications}
            isLocalFiles={true}
          />
        )}
      </div>
    </div>
  );
};

export default SportType;
